import 'react-app-polyfill/ie11.js';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import {
    postVerificationSizeUpdates,
    setOptions,
    DriverLicensePersonalInfoViewModel,
    setViewModel,
    overrideComponent,
} from '@sheerid/jslib';

import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepDriverLicensePersonalInfoComponent } from './components/StepDriverLicensePersonalInfoComponent';

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();

const viewModel: DriverLicensePersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    state: 'CO',
    driverLicenseNumber: '',
    countryChoice: { value: 'US', label: '' },
    localeChoice: { value: 'en-US', label: '' },
};

setViewModel(viewModel);
console.log(viewModel);

// @ts-expect-error
overrideComponent('StepDriverLicensePersonalInfoComponent', StepDriverLicensePersonalInfoComponent);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
